import * as React from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { actions as brandingActions } from '../../../../services/branding/reducer';
import { IBrandingActions, IBrandingState } from '../../../../services/branding/models';
import { IStore } from '../../../../redux/IStore';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { getQuotePolicyApplication } from '../../../../data/api/api';
import steps from '../../steps';
import ValidateRetrieveQuoteModal from '../../scenes/Components/ValidateRetrieveQuoteModal';
import { change } from 'redux-form';
import { DeclineQuote } from '../../scenes/DeclineQuote';
import { push } from 'react-router-redux';

interface IRetrieveQuote extends RouteComponentProps<any> {
  quote: IQuoteState;
  branding: IBrandingState;
  actions: {
    branding: IBrandingActions,
    quote: IQuoteActions,
    push(path: string);
  };
}

class RetrieveQuote extends React.Component<IRetrieveQuote, any> {

  constructor(props) {
    super(props);
    this.state = {
      showValidateModal: false,
      showDeclineModal: false,
    }

    Promise.resolve(props.actions.quote.canRetrieveQuote(props.match.params.id)).then(() => {
      this.setState({ showValidateModal: true })
    }).catch(() => {
      this.setState({ showValidateModal: false, showDeclineModal: true })
    })
  }

  private onCloseModal = () => {
    this.setState({ showValidateModal: false })
    this.getPolicyApplication();
  }

  private getPolicyApplication = () => {
    const { quote, actions, match, branding } = this.props;
    const quoteSteps = steps(branding.channel);
    const promises = [];
    if (!quote.application || quote.application.id !== match.params.id) {
      promises.push(getQuotePolicyApplication(match.params.id).then((policyApplication) => {
        actions.quote.isRetrieving(true)
        actions.quote.isQuoteForEditing(true)
        policyApplication.steps = [quoteSteps[0].key];
        policyApplication.directQuoteRetrieval = true;
        policyApplication.selectedSchemeId = policyApplication.schemeId ? policyApplication.schemeId : '';
        actions.branding.setChannel(policyApplication.channel);
        actions.quote.setCustomer(policyApplication.customer);
        actions.quote.setQuotes(policyApplication.quotes);
        actions.quote.setApplication(policyApplication);
      }));
    }

    Promise.all(promises).then(() => {
      actions.push(quoteSteps[0].route);
    })
  }

  private onDeclineQuote = () => {
    const { actions, match } = this.props;
    const promises = [];
    Promise.all(promises).then(() => {
      Promise.resolve(actions.quote.declineQuote(match.params.id)).then(() => {
        this.setState({ showValidateModal: false, showDeclineModal: true })
      })
    })
  }

  public render() {
    const { match } = this.props;
    const { showValidateModal, showDeclineModal } = this.state;

    return (
      <>
        <ValidateRetrieveQuoteModal showModal={showValidateModal} quoteId={match.params.id}
                                    declineQuote={this.onDeclineQuote} closeModal={this.onCloseModal}/>
        <DeclineQuote showDeclineModal={showDeclineModal}/>
      </>
    )
  }
}

export default flow([
  connect(
    (state: IStore) => ({
      branding: state.branding,
      quote: state.quote,
    }),
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
        change: bindActionCreators(change, dispatch),
      },
    }),
  ),
  withRouter,
])(RetrieveQuote);
